module.exports = require('./distanceProxies').HSVDistanceProxy;